var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isAdminPage)?_c('BlogHeader'):_vm._e(),(_vm.isAdminPage)?_c('AdminSidebar'):_vm._e(),_c('div',{class:_vm.isAdminPage ? 'admin-main' : 'blog-main'},[_c('router-view')],1),(!_vm.isAdminPage)?_c('BlogFooter'):_vm._e(),(!_vm.isAdminPage)?_c('BackToTop'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }